var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-title"},[_c('h2',{},[_vm._v(_vm._s(_vm.title))]),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }